// TODO: deal with tempId deals
import { newId } from "helpers";
import { updateNavigation, updateTemplate } from "../helpers";
import addNewTemplate from "../defaultStates/addNewTemplate";

const newTemplateId = newId();

const defaultState = {
  primaryColor: "#000000",
  secondaryColor: "#000000",
  tertiaryColor: "#000000",
  appCodeAvailable: false,
  purchaseDollarToPointsConversion: 100,
  rewardRedemptionType: 1,
  punchcardRedemptionType: 1,
  // punchcardCode: 1,
  isVerified: 0,
  draft: true,
  name: "",
  address: "",
  links: [
    {
      displayName: "Facebook URL",
      icon: "https://mobile360-assets.s3.us-east-2.amazonaws.com/facebook.png", //default link icon
      url: "",
    },
    {
      displayName: "Instagram URL",
      icon: "https://mobile360-assets.s3.us-east-2.amazonaws.com/instagram.png", //default link icon
      url: "",
    },
    {
      displayName: "Twitter URL",
      icon: "https://mobile360-assets.s3.us-east-2.amazonaws.com/twitter.png", //default link icon
      url: "",
    },
    {
      displayName: "Yelp URL",
      icon: "https://mobile360-assets.s3.us-east-2.amazonaws.com/yelp.png", //default link icon
      url: "",
    },
    {
      displayName: "Snapchat URL",
      icon: "https://mobile360-assets.s3.us-east-2.amazonaws.com/snapchat.png", //default link icon
      url: "",
    },
  ],
  mainImageLink: "",
  code: "",
  hours: "",
  logo: "",
  phoneNumbers: "",
  website: "",
  view: {
    version: 1,
    navigation: {
      navBarColor: "#AED9DA",
      type: "hamburger",
      components: [
        {
          order: 1,
          templateId: newTemplateId,
          title: {
            alignment: 1,
            backgroundColor: "#000000",
            bold: true,
            font: "TimesNewRoman",
            fontSize: 18,
            italics: false,
            text: "Contact",
            textColor: "#000000",
          },
        },
      ],
    },
    templates: [
      {
        id: newTemplateId,
        type: "aboutUs",
        pageName: "Contact",
        backgroundColor: "#FFFFFF",
        backgroundImage: null,
      },
    ],
  },
};

const activeApp = (state = defaultState, action) => {
  Object.freeze(state);
  let newState;
  let published;
  let publishedNavigation;
  switch (action.type) {
    // Applications
    case "RESET_APPLICATION":
      return {
        ...defaultState,
      };
    case "SET_APPLICATION":
      return {
        ...action.app,
      };
    case "UPDATE_APPLICATION":
      return {
        ...state,
        [action.field]: action.value,
      };
    case "UPDATE_APPLICATION_NAVBAR":
      newState = state.view;
      newState.navigation[action.field] = action.value;
      return {
        ...state,
        view: newState,
      };
    case "UPDATE_APPLICATION_IMAGE":
      return {
        ...state,
        mainImageLink: action.image,
      };
    case "UPDATE_APPLICATION_LOGO":
      return {
        ...state,
        logo: action.image,
      };
    case "UPDATE_APPLICATION_INFO":
      return {
        ...state,
        [action.field]: action.value,
      };
    case "ADD_APPLICATION_LINK":
      newState = state.links;
      newState.push({
        id: 0,
        displayName: "",
        icon: "http://cdn2.iconfinder.com/data/icons/network-roundline/512/link-512.png", //default link icon
        url: "",
        appId: "",
      });
      return {
        ...state,
        links: newState,
      };
    case "REMOVE_APPLICATION_LINK":
      newState = state.links;
      newState.splice(action.linkIdx, 1);
      return {
        ...state,
        links: newState,
      };
    case "UPDATE_APPLICATION_LINK":
      newState = state.links;
      newState[action.linkIdx][action.field] = action.value;
      return {
        ...state,
        links: newState,
      };

    // Navigation
    case "UPDATE_NAV_TYPE":
      newState = state;
      newState.view.navigation.type = action.navType;
      return {
        ...newState,
      };
    case "UPDATE_NAV_COLOR":
      newState = state;
      newState.view.navigation.navBarColor = action.navBarColor;
      return {
        ...newState,
      };

    // Template
    case "ADD_NEW_TEMPLATE":
      newState = state;
      const { newTemplate, navComponent } = addNewTemplate(
        action.templateType,
        action.options,
        action.activeApp
      );
      newState.view.templates.push(newTemplate);
      if (!newState.view.navigation.components)
        newState.view.navigation.components = [];
      if (navComponent) {
        let maxOrder = 0;
        newState.view.navigation.components.forEach((c) => {
          if (c.order > maxOrder) maxOrder = c.order;
        });
        navComponent.order = maxOrder + 1;
        newState.view.navigation.components.push(navComponent);
      }
      return {
        ...newState,
      };
    case "UPDATE_TEMPLATE":
      newState = state;
      newState.view.templates = updateTemplate(newState, action.template);
      newState.view.navigation = updateNavigation(newState, action.template);
      return {
        ...newState,
      };
    case "DELETE_TEMPLATE":
      // TODO: refactor into function later
      newState = state;

      // delete from templates
      let templates = newState.view.templates;
      for (let i = 0; i < templates.length; i++) {
        const t = templates[i];
        if (t.id === action.templateId) {
          templates.splice(i, 1);
        }
      }

      // delete from navigation
      let navigation = newState.view.navigation.components;
      for (let i = 0; i < navigation.length; i++) {
        const n = navigation[i];
        if (n.templateId === action.templateId) {
          navigation.splice(i, 1);
        }
      }
      return {
        ...newState,
      };
    case "UNPUBLISH_TEMPLATE":
      newState = state;
      // delete from templates
      published = newState.publishedViews.templates;
      for (let i = 0; i < published.length; i++) {
        const t = published[i];
        if (t.id === action.templateId) {
          // console.log("splicing from published views with id: " + t.id);
          published.splice(i, 1);
        }
      }

      // delete from navigation
      publishedNavigation = newState.publishedViews.navigation.components;
      for (let i = 0; i < publishedNavigation.length; i++) {
        const n = publishedNavigation[i];
        if (n.templateId === action.templateId) {
          publishedNavigation.splice(i, 1);
        }
      }
      return {
        ...newState,
      };

    case "PUBLISH_TEMPLATE":
      newState = state;
      // console.dir(newState);

      published = newState.publishedViews.templates;
      // console.log("printing current published views");
      // console.dir(published);
      // console.log("printing template to add");
      // console.dir(action.template);

      published.splice(0, 0, action.template);

      // console.log("printing new published views with added template");
      // console.dir(published);

      publishedNavigation = newState.publishedViews.navigation.components;
      let unPublishedNavigation = newState.view.navigation.components;

      // console.dir(publishedNavigation);
      for (let i = 0; i < unPublishedNavigation.length; i++) {
        const n = unPublishedNavigation[i];
        if (n.templateId === action.templateId) {
          publishedNavigation.splice(0, 0, n);
        }
      }

      // console.log("printing new published nav views with added template");
      // console.dir(publishedNavigation);
      return {
        ...newState,
      };

    case "REMOVE_ACTIVE_APP_PHONE_NUMBER":
      const { locationIdx, phoneIdx } = action;

      newState = state;
      delete newState.business.locations[locationIdx].phoneNumbers.splice(
        phoneIdx,
        1
      );
      return {
        ...newState,
      };
    default:
      return state;
  }
};

export default activeApp;
